import { create } from "@/store";

export const useCameraSettings = create<Controls>()((set) => ({
  isOpen: false,
  close() {
    set({ isOpen: false });
  },
  open() {
    set({ isOpen: true });
  }
}));
